import _ from 'lodash';

export const expandCollapseByTitleSelector = (state, title) =>
  _.get(state, ['expandedSections', _.camelCase(title)]);
